<script>
	import { library } from "@fortawesome/fontawesome-svg-core";
	import {
		faEye as fasEye,
		faEyeSlash as fasEyeSlash,
	} from "@fortawesome/free-solid-svg-icons";
	import { FontAwesomeIcon } from "fontawesome-svelte";
	import ButtonWrapper from "src/components/ButtonWrapper/ButtonWrapper.svelte";
	import { navigate } from "svelte-routing";
	import { Button, Label } from "sveltestrap";
	import CustomInput from "../components/CustomInput/CustomInput.svelte";
	import ErrorMessageHandler from "../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { doLogin } from "../store/auth/auth";
	import { errorMessage, loading, successMessage } from "../store/store";
	library.add(fasEye, fasEyeSlash);

	let email = "";
	let password = "";
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
	async function submit() {
		doLogin({ email, password });
	}
	let load;
	loading.subscribe((value) => {
		load = value;
	});

	const handleNavigate = (value) => {
		errorMessage.set("");
		successMessage.set("");
		navigate("forgot-password");
	};

	let show = false;

	const handleShow = () => {
		if (show) {
			show = false;
		} else {
			show = true;
		}
	};

	const onKeyPress = (e) => {
		if (e.charCode === 13) submit();
	};
</script>

<main>
	<div class="main-container">
		<div class="left">
			<div
				class="d-flex flex-column align-items-center justify-content-center w-100"
			>
				<div>
					<img
						src="/assets/getgo-logo-descriptor.png"
						alt="getgologo"
						style="width: 200px; height: 113px"
					/>
				</div>
				<div class="copyright">
					<span> Copyright © 2025. All Rights Reserved </span>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="sign-in">
				<h2>GetGo FMS</h2>
				<ErrorMessageHandler message={err} />
				<div class="mt-3 mb-1">
					<Label for="email">
						<b>Email</b>
					</Label>
				</div>
				<div>
					<CustomInput id="email" type="email" bind:value={email} />
				</div>
				<div class="mt-3 mb-1">
					<Label for="password">
						<b>Password</b>
					</Label>
				</div>

				<div class="position-relative">
					<CustomInput
						id="password"
						type={!show ? "password" : "text"}
						bind:value={password}
						keypress={onKeyPress}
					/>
					<span
						class="text-count"
						style="
                            position: absolute;
                            bottom: 27%;
                            right: 18px;"
					>
						<ButtonWrapper
							onClick={handleShow}
							onKeyDown={() => {}}
							on:keydown={() => {}}
						>
							{#if show}
								<FontAwesomeIcon icon={fasEye} />
							{:else}
								<FontAwesomeIcon icon={fasEyeSlash} />
							{/if}
						</ButtonWrapper>
					</span>
				</div>
				<div />
				<div class="forgot my-4">
					<ButtonWrapper
						onClick={handleNavigate}
						onKeyDown={() => {}}
						on:keydown={() => {}}
					>
						<b class="link font-weight-bold"> Forgot password? </b>
					</ButtonWrapper>
				</div>
				{#if !load}
					<div class="my-2">
						<Button
							block
							class="themeButton primary"
							on:click={submit}
							disabled={load || !email || !password}
						>
							Log in
						</Button>
					</div>
				{:else}
					<div class="my-2">
						<Button
							block
							class="themeButton primary"
							type="button"
							disabled
						>
							<output
								class="spinner-grow spinner-grow-sm"
								aria-hidden="true"
							/>
							Signing you in...
						</Button>
					</div>
				{/if}
			</div>
		</div>
	</div>
</main>
